export const TAKEOVER_SIZE = 525;
export const MULTI_SELECT_OPTION_LIMIT = 5;

export const RETENTION_PERIOD_OPTIONS = [
  { id: '7-days', label: '7 days', value: '7' },
  { id: '14-days', label: '14 days', value: '14' },
  { id: '30-days', label: '30 days', value: '30' },
];

export const DEFAULT_SETTINGS = {
  isRetentionEnabled: false,
  selectedRetentionOption: '14',
  selectedListOptions: [],
};

export const CONTENT = {
  takeover: {
    title: 'Unknown User Criteria',
    cancelButton: 'Cancel',
    saveButton: 'Save changes',
  },
  header: {
    retentionPeriod: 'Retention period',
  },
  form: {
    enableRetentionLabel: 'Enable retention period for unknown users',
    enableRetentionDescription:
      "Automatically remove unknown users that haven't converted to known after a specified period.",
    retentionPeriodLabel: 'Retention period',
    retentionPeriodDescription:
      'Unknown users (created through the unknown session API) without an email or user ID, will be deleted from this project if they stay unknown within the set timeframe.',
    excludeUsersLabel: 'Exclude users',
    excludeUsersDescription:
      'Users in the selected lists will remain in the project, regardless of their inactivity.',
    multiSelectPlaceholder: 'Search or select a list...',
  },
  errors: {
    settingsLoadError: 'Unable to load retention settings',
    listsLoadError: 'Error loading lists',
    genericError: 'Please try again later. If the problem persists, contact your CSM.',
    listsGenericError: 'Unable to load lists. Please try again.',
  },
  lastModified: {
    prefix: 'Last modified ',
  },
};
